<template>
    <div style="background:#fff">
        <div style="width:1400px; margin:0 auto; padding:10px 0;">
            <a-breadcrumb class="page_breadcrumb">
                <a-breadcrumb-item><router-link :to="{name:'menu'}">游戏专项</router-link></a-breadcrumb-item>
                <a-breadcrumb-item>{{parent}}</a-breadcrumb-item>
                <a-breadcrumb-item>{{name}}</a-breadcrumb-item>
            </a-breadcrumb>
        </div>
        <div class="nsh1ce_ctrl_container nsh1ce">

            <!-- 逆水寒board -->
            <div class="nsh1ce_board">
                <div class="board-item" v-for="(it, it_key) in datas.board" :key="it_key">
                    <h3>【数据链接】</h3>
                    <ul class="list list-shortcut">
                        <li v-for="(iit, index) in it.link" :key="index">
                        <a :href="iit.href?`game.html?proj=nsh#/page?id=${ iit.href }`:''">{{ iit.title }}</a>
                        </li>
                    </ul>
                    <h3>【敏捷报告】</h3>
                    <ul class="list">
                    <li>请至[<a href="http://dc.leihuo.netease.com/uxdoc/" target="_blank">知识分享平台</a>]查看报告</li>
                    </ul>
                </div>
            </div>

            <!-- 表格 -->
            <div class="nsh1ce_ctrl_tables" v-for="table in [0,1]" :key="table">
                <div class="table_title">
                    <h2>{{ datas.results[table].title }}</h2>
                </div>
                <ul class="nav-group">
                    <li class="text">分组选择：</li>
                    <li role="presentation" :class="{active: datas.results[table].active == it.id}" v-for="it in datas.results[table].groupNav" @click="select(table, it.id)" :key="it.title">
                        <a href="javascript:;">{{ it.title }}</a>
                    </li>
                </ul>
                <DataTable :fields="datas.results[table].thead" :datas="datas.results[table].data" class="nsh1ce_ctrl_table" :paging="false" :lock="table==3?true:false" :ref="`table_${table}`"/>
                <div class="tips">
                    <p class="tip" v-if="table!=3">登录、留存：首日激活账号后续的登录、留存情况；<br />平均在线时长：截止到数据获取时该组别玩家平均在线时长（分钟）</p>
                    <p class="tip" v-if="table==3">参与率：参与角色ID数/可参加等级及以上登录角色ID数；<br />完成率：完成角色ID数/参与角色ID数<br />（如玩法有多个任务或多个副本，角色通过一个任务或副本即为完成，次数完成率详见玩法参与率完成率）</p>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
const groupNav = [
  { id: 0, title: '重点', sub: [{ id: 1, title: '标准玩家' }, { id: 2, title: '男' }, { id: 3, title: '女' }, { id: 4, title: '学生' }, { id: 5, title: '上班族' }, { id: 6, title: '天刀组' }, { id: 7, title: '剑网组' }, { id: 8, title: '固定视角' }, { id: 9, title: '自由视角' }, { id: 10, title: '极端玩家(30人)' }] },
  { id: 'gender', title: '性别', sub: [{ id: 1, title: '男' }, { id: 2, title: '女' }] },
  { id: 'age', title: '年龄', sub: [{ id: 1, title: '00后(18岁以下)' }, { id: 2, title: '95后(19~23岁)' }, { id: 3, title: '90后(24~28岁)' }, { id: 4, title: '80后(29~38岁)' }, { id: 5, title: '70后(39~48岁)' }, { id: 6, title: '60后(49岁以上)' }] },
  { id: 'occupation', title: '职业', sub: [{ id: 1, title: '学生' }, { id: 2, title: '上班族' }, { id: 3, title: '自由职业' }, { id: 4, title: '个体经营者/私企老板' }, { id: 5, title: '其他' }] },
  { id: 'game_played', title: '武侠古风端游经历', sub: [{ id: 1, title: '天刀' }, { id: 2, title: '剑网' }, { id: 3, title: '天谕' }, { id: 4, title: '九阴' }, { id: 5, title: '倩女' }, { id: 6, title: '天龙' }, { id: 7, title: '笑傲' }, { id: 8, title: '天下' }, { id: 9, title: '武魂' }, { id: 10, title: '梦幻' }, { id: 11, title: '古剑奇谭' }, { id: 12, title: '魔兽' }, { id: 13, title: 'LOL' }, { id: 14, title: '剑灵' }, { id: 15, title: '大话西游' }, { id: 16, title: '镇魔曲' }, { id: 17, title: '暗黑' }, { id: 18, title: '其他武侠' }] },
  { id: 'is_novel_tv_fans', title: '原著电视剧电视剧接触情况', sub: [{ id: 1, title: '均未看过' }, { id: 2, title: '只看过原著' }, { id: 3, title: '只看过电视剧' }, { id: 4, title: '看过原著和电视剧' }] },
  { id: 'game_passion', title: '每日玩端游时长习惯', sub: [{ id: 1, title: '每天不到半小时' }, { id: 2, title: '每天半小时-1小时' }, { id: 3, title: '每天1-2小时' }, { id: 4, title: '每天2-4小时' }, { id: 5, title: '每天4-6小时' }, { id: 6, title: '每天6小时以上' }] },
  { id: 'change_novel', title: '原著改编态度', sub: [{ id: 0, title: '无态度' }, { id: 1, title: '原著忠实党(看过原著且希望忠于原著)' }, { id: 2, title: '原著改编党(看过原著希望部分改编原著)' }] },
  { id: 'view_prefence', title: '游戏视角偏好', sub: [{ id: 1, title: '2D&2.5D&3D玩家' }, { id: 2, title: '2D&2.5D玩家' }, { id: 3, title: '偏2.5D玩家' }, { id: 4, title: '偏2D玩家' }] },
  { id: 'which_view', title: '希望逆水寒是哪种游戏视角', sub: [{ id: 1, title: '固定视角' }, { id: 2, title: '自由视角' }, { id: 3, title: '两种视角可以切换' }] },
]

const groupKey = groupNav.reduce((ret, it) => {
  ret[it.id] = it.sub.reduce((rret, iit) => {
    rret[iit.id] = iit.title
    return rret
  }, {})
  return ret
}, {})


const groupNav1 = [
  { id: 'all_video_card', title: '全部', sub: [{ id: 1, title: '高端显卡' }, { id: 2, title: '中端显卡' }, { id: 3, title: '低端显卡' }] },
  { id: 'male_video_card', title: '男', sub: [{ id: 1, title: '高端显卡' }, { id: 2, title: '中端显卡' }, { id: 3, title: '低端显卡' }] },
  { id: 'female_video_card', title: '女', sub: [{ id: 1, title: '高端显卡' }, { id: 2, title: '中端显卡' }, { id: 3, title: '低端显卡' }] },
  { id: 'student_video_card', title: '学生', sub: [{ id: 1, title: '高端显卡' }, { id: 2, title: '中端显卡' }, { id: 3, title: '低端显卡' }] },
  { id: 'occupation_video_card', title: '上班族', sub: [{ id: 1, title: '高端显卡' }, { id: 2, title: '中端显卡' }, { id: 3, title: '低端显卡' }] },
  { id: 'tiandao_video_card', title: '天刀组', sub: [{ id: 1, title: '高端显卡' }, { id: 2, title: '中端显卡' }, { id: 3, title: '低端显卡' }] },
  { id: 'jianwang_video_card', title: '剑网组', sub: [{ id: 1, title: '高端显卡' }, { id: 2, title: '中端显卡' }, { id: 3, title: '低端显卡' }] },
  { id: 'qiannv_video_card', title: '倩女组', sub: [{ id: 1, title: '高端显卡' }, { id: 2, title: '中端显卡' }, { id: 3, title: '低端显卡' }] },
  { id: '25d_video_card', title: '偏2.5D玩家', sub: [{ id: 1, title: '高端显卡' }, { id: 2, title: '中端显卡' }, { id: 3, title: '低端显卡' }] },
  { id: '2d_25d_3d_video_card', title: '2D&2.5D&3D玩家', sub: [{ id: 1, title: '高端显卡' }, { id: 2, title: '中端显卡' }, { id: 3, title: '低端显卡' }] },
]

const groupKey1 = groupNav1.reduce((ret, it) => {
  ret[it.id] = it.sub.reduce((rret, iit) => {
    rret[iit.id] = iit.title
    return rret
  }, {})
  return ret
}, {})

import DataTable from '@/components/common/datatable.vue'
import {ctrlMixin} from '@/utils/ctrlMixin.js'
export default {
    mixins: [ctrlMixin],
    name:'nsh1ce',
    props: ['parent', 'name'],
    components: {
        DataTable,
    },
    mounted(){
        this.initData()
    },
    data() {
        return {
            datas: {
                board: {
                    721: {
                    report: [],
                    link: [
                        { href: '1239', title: '落枫山庄' },
                        { href: '1322', title: '飞檐掠宝' },
                        { href: '1399', title: '天下风云出我辈' },
                        { href: '1159', title: '主线-新手村' },
                        { href: '1160', title: '主线-汴京(一)' },
                    ],
                    },
                    722: {
                    report: [],
                    link: [
                        { href: '1234', title: '清明上河' },
                        { href: '1427', title: '科举' },
                        { href: '1399', title: '天下风云出我辈' },
                        { href: '1347', title: '试剑天下' },
                        { href: '1415', title: '论武' },
                    ],
                    },
                    723: {
                    report: [],
                    link: [
                        { href: '1239', title: '落枫山庄' },
                        { href: '1413', title: '比武大会' },
                        { href: '1322', title: '飞檐掠宝' },
                        { href: '1390', title: '雄图霸业弹指间' },
                        { href: '1347', title: '试剑天下' },
                        { href: '1415', title: '论武' },
                    ],
                    },
                    724: {
                    report: [],
                    link: [
                        { href: '1234', title: '清明上河' },
                        { href: '1322', title: '飞檐掠宝' },
                        { href: '1395', title: '迷天卷土无用处' },
                        { href: '1347', title: '试剑天下' },
                        { href: '1415', title: '论武' },
                    ],
                    },
                    725: {
                    report: [],
                    link: [
                        { href: '1239', title: '落枫山庄' },
                        { href: '1322', title: '飞檐掠宝' },
                        { href: null, title: '不胜人生一场醉' },
                        { href: '1347', title: '试剑天下' },
                        { href: '1415', title: '论武' },
                    ],
                    },
                    726: {
                    report: [],
                    link: [
                        { href: '1234', title: '清明上河' },
                        { href: '1322', title: '飞檐掠宝' },
                        { href: '1362', title: '胜者为王' },
                        { href: '1371', title: '帮会联赛' },
                    ],
                    },
                    727: {
                    report: [],
                    link: [
                        { href: '1239', title: '落枫山庄' },
                        { href: '1322', title: '飞檐掠宝' },
                        { href: '1371', title: '帮会联赛' },
                    ],
                    },
                },
                results: [
                    {
                    title: '玩家留存情况',
                    active:0,
                    groupNav,
                    groupKey,
                    thead: [{id:'title', title:'组别'}, {title:'首日', children: [{id:'first_account_cnt', title:'登录'}, {id:'online_0', title:'在线'}]}, {title:'次日', children: [{id:'lc_1', title:'留存'}, {id:'online_1', title:'在线'}]}, {title:'第3日', children: [{id:'lc_2', title:'留存'}, {id:'online_2', title:'在线'}]}, {title:'第4日', children: [{id:'lc_3', title:'留存'}, {id:'online_3', title:'在线'}]}, {title:'第5日', children: [{id:'lc_4', title:'留存'}, {id:'online_4', title:'在线'}]}, {title:'第6日', children: [{id:'lc_5', title:'留存'}, {id:'online_5', title:'在线'}]}, {title:'第7日', children: [{id:'lc_6', title:'留存'}, {id:'online_6', title:'在线'}]}],
                    data: [],
                }, {
                    title: '玩家硬件分组留存情况',
                    active:'all_video_card',
                    groupNav: groupNav1,
                    groupKey: groupKey1,
                    thead: [{id:'title', title:'组别'}, {title:'首日', children: [{id:'first_account_cnt', title:'登录'}, {id:'online_0', title:'在线'}]}, {title:'次日', children: [{id:'lc_1', title:'留存'}, {id:'online_1', title:'在线'}]}, {title:'第3日', children: [{id:'lc_2', title:'留存'}, {id:'online_2', title:'在线'}]}, {title:'第4日', children: [{id:'lc_3', title:'留存'}, {id:'online_3', title:'在线'}]}, {title:'第5日', children: [{id:'lc_4', title:'留存'}, {id:'online_4', title:'在线'}]}, {title:'第6日', children: [{id:'lc_5', title:'留存'}, {id:'online_5', title:'在线'}]}, {title:'第7日', children: [{id:'lc_6', title:'留存'}, {id:'online_6', title:'在线'}]}],
                    data: [],
                }],
            },
        }
    },
    methods: {
        initData() {
            this.loading = true
            let q_lc1 = this.$service.query(this.queryId, {flag:0, subtype:0});
            let q_lc2 = this.$service.query(this.queryId, {flag:1, subtype:'all_video_card'});

            Promise.all([q_lc1, q_lc2]).then((datas) => {
                datas[0].forEach((row, index)=>{
                    row.id = index+1
                    row.title = this.datas.results[0].groupKey[0][row.id]
                })
                datas[1].forEach((row, index)=>{
                    row.title = this.datas.results[1].groupKey['all_video_card'][row.id]
                })

                this.datas.results[0].data = datas[0]
                this.datas.results[1].data = datas[1]
                this.loading = false
            }).catch((errors)=>{
                console.log(errors)
                this.loading = false
            })
        },
        select(index, id) {
            if (id === this.datas.results[index].active) {
                return
            }
            this.datas.results[index].active = id
            this.datas.results[index].data = this.datas.results[index].groupNav.filter(it => it.id === id)[0].sub

            this.$service.query(this.queryId, {flag:index, subtype:id}).then((data)=>{
                if (id === 0 || id === 2 || id === 'game_played' || id === 'innergame') {
                    data.forEach((it, idx) => {
                        it.id = idx + 1
                    })
                }
                data.forEach((it) => {
                    it.title = this.datas.results[index].groupKey[id][it.id]
                })
                this.datas.results[index].data = data
            })
        },
    }
}
</script>
<style lang="less">
@width:1500px;

// 刷新按钮动画
@keyframes scale {
    0% {
        transform: scale(1);
        opacity: .7
    }
    50% {
        transform: scale(1.5);
        opacity: 0
    }
    99% {
      transform: scale(1);
      opacity: 0
    }
    100% {
        transform: scale(1);
        opacity: .7
    }
}

@keyframes spin {
    0% {
        -webkit-transform: rotate(0deg);
        transform: rotate(0deg)
    }

    100% {
        -webkit-transform: rotate(359deg);
        transform: rotate(359deg)
    }
}

.nsh1ce_ctrl_container {
    overflow: hidden;
    min-height: 700px;
    a {
        color: #a89371;
    }
    .nsh1ce_ctrl_content_container {
        width:@width;
        margin:0 auto;
    }
    .nsh1ce_ctrl_title {
        height:100px;
        width:100%;
        margin:0 0 40px 0;
        .refresh_btn {
            position:absolute;
            left: 50%;
            margin:25px 0 0 250px;
            width: 50px;
            height: 50px;
            text-align: center;
            cursor: pointer;
            border-width: 0;
            background-color: transparent;
            color: rgba(0, 0, 0, .3);

            i {
                font-size: 25px;
                line-height: 55px;
            }
            &:hover {
                animation: spin 2s infinite linear;
            }
            &:hover:after {
                animation: none;
            }
            &:after {
                content: "";
                position: absolute;
                left: 0;
                top: 0;
                height: 50px;
                width: 50px;
                border-radius: 100%;
                border: 1px solid rgba(0, 0, 0, .3);
                animation: scale 2s ease infinite;
            }
        }
    }

    .nsh1ce_ctrl_tables {
        margin:0 auto;
        margin-top:20px;
        margin-bottom:30px;
        width: 1600px;
        .table_title {
            position: relative;
            text-align: center;
            margin:50px 0 30px 0;
            h2 {
                color: #a89371; 
                font-size:20px;
                &:before {
                    position:absolute;
                    content:' ';
                    top: 50%;
                    left:0;
                    width:40%;
                    border-bottom: 1px solid #a89371;
                }
                &:after {
                    position:absolute;
                    content:' ';
                    top: 50%;
                    right:0;
                    width:40%;
                    border-bottom: 1px solid #a89371;
                }
            }
        }
        .nsh1ce_ctrl_table {
            .ant-table-middle > .ant-table-content > .ant-table-body > table > .ant-table-thead > tr > th {
                padding:5px 0;
            }
            .ant-table-tbody > tr:nth-child(2n) td{
                background:#e9e9e9;
            }
            .ant-table-tbody > tr:hover td{
                background:#e6f7ff;
            }
            .data_table .ant-table-middle > .ant-table-content > .ant-table-body > table > .ant-table-tbody > tr > td > div {
                padding: 5px 0px;
            }

            .ant-table-middle > .ant-table-content > .ant-table-scroll > .ant-table-header > table > .ant-table-thead > tr > th {
                padding:5px 0;
            }
            .ant-table-middle > .ant-table-content > .ant-table-scroll > .ant-table-body > table > .ant-table-tbody > tr > td {
                padding:5px 0;
            }
        }
        .tips {
            margin:20px 0 0 0;
            color:#777;
            text-align: center;
        }

        .nav-group {
            display: inherit;
            flex-wrap: wrap;
            li:after {
                content: "/";
                color: #bbb;
            }
            .text {
                padding: 10px;
            }
        }
        .nav-group li:first-child:after,
        .nav-group li:last-child:after,
        .nav-group .text:after {
        content: "";
        }
        .nav-group li.active a {
            color: #41cac0;
            font-weight: 600;
        }
        .nav-group a,
        .nav-group .refresh {
            color:#a89371;
            display: inline-block;
            vertical-align: middle;
            padding: 10px 15px;
            white-space: nowrap;
        }
        .nav-group .refresh {
            color: #9a7f54;
            border: 1px solid currentColor;
                border-radius: 4px;
                background-color: transparent;
        }
        .nav-group .refresh:hover {
            color: #41cac0;
        }
        .nav-group .refresh[disabled] {
            color: #aaa;
        }
        .nav-group{text-align:center}
        .nav-group li{display:inline-block;}
    }

    &.nsh1ce {
        padding:70px 0 0 0;
        background: url('../../../assets/img/ctrl/nsh/bg.jpg');
        .nsh1ce_ctrl_title {
            background: url('../../../assets/img/ctrl/nsh/2ce_title.png') center no-repeat;
        }
    }

    .nsh1ce_realtime {
        margin:20px 0 20px 0;
        .realtime_item_container {
            display: flex;
            justify-content: center;
            
            .realtime_item {
                border-radius: e('50%/50%');
                text-align: center;
                background-color: rgb(210, 179, 105);
                margin-right: 5px;
                color: #fff;
                span {
                    display: block;
                    padding: 7px 20px 3px 20px;
                    &:last-child {
                        padding: 3px 20px 7px 20px;
                        border-top: 1px solid #fff;
                    }
                }
            }
        }
        .realtime_tip {
            color: rgb(210, 179, 105);
            text-align: center;
            white-space: nowrap;
            margin:10px 0 0 0;
        }
    }

    @mainColor:#a89371;
        
    .nsh1ce_board {
        width: @width;
        position: relative;
        margin:0 auto;
        margin-top: 10px;
        margin-bottom: 20px;
        padding: 95px 10px 0 25px;
        border: 10px solid #d1c0a5;
        &:before {
            content: "";
            position: absolute;
            width: 493px;
            height: 95px;
            left: 50%;
            margin-left: -246px;
            top: -60px;
            background: url(../../../assets/img/ctrl/nsh/1ce_title.png) no-repeat;
            z-index: 1;
        }
        &:after {
            content: "";
            position: absolute;
            border: 2px solid #d1c0a5;
            left: 10px;
            top: 10px;
            bottom: 10px;
            right: -20px;
            z-index: 0;
        }


        .board-item {
        vertical-align: top;
        text-align: center;
        padding: 70px 10px 10px;
        color: #a89371;
        position: relative;
        width: 12%;
        border: 3px solid #d1c0a5;
        display: inline-block;
        margin-left: 2%;
        margin-bottom: 40px;
        &:before {
            content: "";
            left: 50%;
            margin-left: -45px;
            top: -45px;
            z-index: 1;
            position: absolute;
            width: 90px;
            height: 90px;
            background: url(../../../assets/img/ctrl/nsh/1ce_days.png) no-repeat;
        }
        &:after {
            content: "";
            position: absolute;
            left: 5px;
            top: 5px;
            bottom: 5px;
            right: -8px;
            border: 1px solid #d1c0a5;
            background: rgba(236, 215, 181, 0.25);
            z-index: 0;
        }
        }

        .board-item:nth-of-type(1):before { background-position: 0 0; }
        .board-item:nth-of-type(2):before { background-position: 0 -90px; }
        .board-item:nth-of-type(3):before { background-position: 0 -180px; }
        .board-item:nth-of-type(4):before { background-position: 0 -270px; }
        .board-item:nth-of-type(5):before { background-position: 0 -360px; }
        .board-item:nth-of-type(6):before { background-position: 0 -450px; }
        .board-item:nth-of-type(7):before { background-position: 0 -540px; }
        .board-item a {
            position: relative;
            z-index:1;
        }
        .board-item h3 {font-size:18px; margin-top: 0;margin-bottom: 0; }
        .board-item .list { padding:0; font-size:13px; line-height:20px; margin:10px 0;}
        .board-item .list li {color: #666; }
        .board-item .list a:hover{color:#9a7f54; text-decoration:underline;}
        .board-item .list-shortcut { height:120px; }
        .board-item .list:nth-of-type(2) li { padding-bottom: 5px; margin-bottom: 5px; border-bottom: 1px dashed #a89371; }
        .board-item .list:nth-of-type(2) li:last-child { border-bottom-width: 0; }
    }
}
</style>